import { render, staticRenderFns } from "./SacAverageTimeForTreatmentsByPage.vue?vue&type=template&id=49c4bde3&"
import script from "./SacAverageTimeForTreatmentsByPage.vue?vue&type=script&lang=js&"
export * from "./SacAverageTimeForTreatmentsByPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports